<template>
    <div style="display: contents">
        <v-btn class="ma-2 close"
               @click="stop"
               outlined
               x-small
               fab
               color="red">
          <v-icon>
            mdi-close
          </v-icon>
      </v-btn>

      <div class="spinner mr-2"/>

      <time class="recorder-timer">
        {{timer.text}}
      </time>

      <v-btn class="ma-2 check"
             @click="send()"
             color="green"
             outlined
             x-small
             fab>
        <v-icon>
          mdi-check
        </v-icon>
      </v-btn>
    </div>
</template>

<script>
import notifications from '@/libs/notifications'
import Recorder from 'opus-recorder'
export default {
  created () {
    this.checkPermission()
  },
  data: () => ({
    isRecordingSupported: false,
    readyForSend: false,
    recorder: null,
    timer: {
      hours: 0,
      minutes: 0,
      seconds: 0,
      text: '00:00',
      time: null
    },
    uploadProgress: 0
  }),
  methods: {
    audioTimer () {
      this.timer.seconds++
      if (this.timer.seconds >= 60) {
        this.timer.seconds = 0
        this.timer.minutes++
        if (this.timer.minutes >= 60) {
          this.timer.minutes = 0
          this.timer.hours++
        }
      }

      this.timer.text =
          (this.timer.minutes ? (this.timer.minutes > 9 ? this.timer.minutes : '0' + this.timer.minutes) : '00') + ':' +
          (this.timer.seconds > 9 ? this.timer.seconds : '0' + this.timer.seconds)

      this.timerCount()
    },
    checkPermission () {
      navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(() => {
        this.isRecordingSupported = true
      }).catch(() => {
        this.isRecordingSupported = false
      })
    },
    clearTime () {
      clearTimeout(this.timer.time)
      this.timer.text = '00:00'
      this.timer.seconds = 0
      this.timer.minutes = 0
      this.timer.hours = 0
    },
    send () {
      this.readyForSend = true
      this.stop()
    },
    async start () {
      await this.checkPermission()
      if (!this.isRecordingSupported) {
        notifications.error('No se encontraron dispositivos de entrada o debes dar permisos en el navegador')
        this.$emit('stop')
        return
      }
      this.timerCount()
      this.recorder.start()
    },
    stop () {
      this.clearTime()
      this.recorder.stop()
      this.$emit('stop')
    },
    timerCount () {
      this.timer.time = setTimeout(this.audioTimer, 1000)
    },
    urlWorker () {
      if (process.env.VUE_APP_NODE_ENV === 'development') return 'http://localhost:8080'
      if (process.env.VUE_APP_NODE_ENV === 'test') return 'https://apptest.keybe.bio'
      return 'https://app.keybe.bio'
    }
  },
  props: ['recording', 'value'],
  watch: {
    recording (value) {
      if (value) {
        this.start()
      }
    }
  },
  mounted () {
    this.recorder = new Recorder({ encoderPath: 'https://conversations.keybe.bio/static/b4c5d1bd5eec0720ecf5253126cf1b1f.js' })
    this.isRecordingSupported = Recorder.isRecordingSupported()
    this.recorder.ondataavailable = (array) => {
      const file = new File([array], 'audio.ogg', { type: 'audio/ogg', lastModified: new Date() })
      this.$emit('input', file)
      if (this.readyForSend) {
        this.$emit('send')
        this.readyForSend = false
      }
    }
  }
}
</script>

<style>
  .close:hover {
    background-color: rgba(229, 37, 37, 0.95);
    animation: zoomIn 5s -3s;
    color: white !important;
  }
  .check:hover {
    background-color: #55db55;
    animation: zoomIn 5s -3s;
    color: white !important;
  }
  @keyframes zoomIn {
    from { transform: scale(0) }
  }
  .spinner {
    width: 19px;
    height: 15px;
    margin: 20px auto;
    background-color: #dc2743;

    border-radius: 100%;
    -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
    animation: sk-scaleout 1.0s infinite ease-in-out;
  }
  .recorder-timer {
    min-width: 50px;
  }

  @-webkit-keyframes sk-scaleout {
    0% { -webkit-transform: scale(0) }
    100% {
      -webkit-transform: scale(1.0);
      opacity: 0;
    }
  }

  @keyframes sk-scaleout {
    0% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 100% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
        opacity: 0;
      }
  }
</style>
